module.exports = __webpack_public_path__ + "img/img33.59b0a0f9.svg";